import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Tranfer RX Form
   */
  {
    label: 'Please upload an image of your prescription or drug label',
    field: 'transferRx',
    type: 'file_upload',
    // questionImage: 'https://cdn.buttercms.com/Qg4VfomnTNM4Iy7JzU2Y',
    answer: [
      {
        resourceId: 'transfer_Rx',
        buttonLabel: 'Upload Prescription'
      }
    ]
  },
  {
    // 2
    label: 'Tell us more!',
    subLabel: '(Please write your answer in the space provided)',
    field: 'transferRX2',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Name of pharmacy',
          type: 'text',
          name: 'transferRXPharamcyName'
        },
        {
          label: 'Location of pharamcy',
          type: 'text',
          name: 'transferRXPharamcyLocation'
        },
        {
          label: 'Name of medication(s) or write transfer my whole file',
          type: 'text_list',
          name: 'transferRxMeds',
          inputPlaceholder: 'Medication Name'
        }
      ]
    }
  },
  {
    label: 'Would you like us to',
    field: 'transferRX3',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'dipsense',
          value: 'Dispense and ship my medication right away'
        },
        {
          key: 'hold',
          value:
            'Put my prescription on hold for now, I will order it when I need it'
        }
      ]
    }
  }
];

export default questionsModels;
